import { useMemo } from "react";
import { useGetEmployeeWorkRulesQuery } from "../gql/graphql.generated";
import { defaultStaffSettings } from "../settings/systemSettings.types";
import { useEmployeeList } from "../staff/useEmployeeList";

export function useWorkRules(employeeId: string) {
  const { allEmployees: employees } = useEmployeeList({ includeDeleted: true });

  const employeeIds = useMemo(() => employees.map(emp => emp.identityId), [employees]);
  const [{ data: workRulesData }, refetchWorkRules] = useGetEmployeeWorkRulesQuery({
    variables: { employeeIds: employeeIds }
  });

  const rules = workRulesData?.workRulesByEmployeeIds?.find(wr => wr.identityId === employeeId);
  
  return {
    rules: {
      minMonthlyHours:
        rules?.minHoursPerMonth === undefined ? defaultStaffSettings.minMonthlyHours : rules.minHoursPerMonth,
      maxMonthlyHours:
        rules?.maxHoursPerMonth === undefined ? defaultStaffSettings.maxMonthlyHours : rules.maxHoursPerMonth,
      minWeeklyHours:
        rules?.minHoursPerWeek === undefined ? defaultStaffSettings.minWeeklyHours : rules.minHoursPerWeek,
      maxWeeklyHours:
        rules?.maxHoursPerWeek === undefined ? defaultStaffSettings.maxWeeklyHours : rules.maxHoursPerWeek
    },
    refetch: refetchWorkRules
  }
}
